import { render, staticRenderFns } from "./FollowWechat.vue?vue&type=template&id=020df37b&scoped=true"
import script from "./FollowWechat.vue?vue&type=script&lang=js"
export * from "./FollowWechat.vue?vue&type=script&lang=js"
import style0 from "./FollowWechat.vue?vue&type=style&index=0&id=020df37b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020df37b",
  null
  
)

export default component.exports